// src/pages/LaunchGamePage.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/app-theme.css';

const LaunchGamePage: React.FC = () => {
  const navigate = useNavigate();

  console.log('==========================================');
  console.log('LaunchGamePage: Component mounted');
  console.log('Game URL:', process.env.REACT_APP_GAME_URL);
  console.log('==========================================');

  useEffect(() => {
    console.log('==========================================');
    console.log('LaunchGamePage: useEffect triggered');
    console.log('Adding message listener to window');
    
    const messageHandler = (event: MessageEvent) => {
      console.log('==========================================');
      console.log('Received message:', event.data);
      console.log('Message origin:', event.origin);
      console.log('==========================================');
      
      if (event.data?.type === 'GAME_READY') {
        console.log('GAME_READY received, preparing to send auth data');
        const gameFrame = document.getElementById('game-frame');
        if (!gameFrame) {
          console.error('Game frame not found!');
          return;
        }

        // Get auth data
        const token = sessionStorage.getItem('token');
        const userId = sessionStorage.getItem('userId');
        const emailAddress = sessionStorage.getItem('emailAddress');
        const sanityToken = sessionStorage.getItem('sanityToken');

        console.log('Auth data available:', {
          hasToken: !!token,
          hasUserId: !!userId,
          hasEmail: !!emailAddress,
          hasSanity: !!sanityToken
        });

        try {
          (gameFrame as HTMLIFrameElement).contentWindow?.postMessage({
            type: 'AUTH_DATA',
            userId,
            token,
            sanityToken,
            email: emailAddress
          }, process.env.REACT_APP_GAME_ORIGIN  || '*');
          console.log('Auth data sent successfully');
        } catch (error) {
          console.error('Error sending auth data:', error);
        }
      }
    };

    window.addEventListener('message', messageHandler);
    console.log('Message listener added');
    console.log('==========================================');

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, [navigate]);

  return (
    <div style={{
      padding: '2rem',
      textAlign: 'center',
      color: 'var(--text-header)',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <iframe
        id="game-frame"
        src={process.env.REACT_APP_GAME_URL}
        style={{
          border: 'none',
          flex: 1,
          width: '100%',
          height: '100%'
        }}
        title="Re-Word Game"
        onLoad={() => console.log('iframe loaded')}
      />
    </div>
  );
};

export default LaunchGamePage;